/* ==========================================================================
   CAT JOY theme JS (vanilla, no dependencies). Ported from the Next.js storefront.
   Header pill · mobile drawer · reveal · hero video · countdowns (deal / dispatch) ·
   product cards (colour dots, quick add) · favourites · recently viewed · PDP
   (gallery, swatches, qty, sticky bar, lightbox) · chat paw · back-to-top ·
   paw trail · welcome popup · footer accordion · rail nudge · collection sort.
   ========================================================================== */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var on = function (el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); };
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CFG = w.catjoy || {};
  var money = function (cents) {
    var v = (cents / 100);
    var s = v.toFixed(2).replace(/\.00$/, '');
    return (CFG.currency || '£') + s;
  };
  var ls = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    raw: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    put: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- header ---------- */
  function initHeader() {
    var hdr = $('header.hdr');
    if (!hdr) return;
    var onScroll = function () { hdr.classList.toggle('hdr--scrolled', w.scrollY > 24); };
    onScroll();
    on(w, 'scroll', onScroll, { passive: true });

    var mnav = $('.mnav');
    if (!mnav) return;
    /* The page behind the drawer is frozen (position:fixed) so iOS Safari's toolbars stay put and the panel never jumps. */
    var lockY = 0;
    var open = function () {
      lockY = w.scrollY || 0;
      root.style.setProperty('--cj-lock', (-lockY) + 'px');
      mnav.classList.add('open'); d.body.classList.add('cj-menu-open'); mnav.setAttribute('aria-hidden', 'false');
    };
    var close = function () {
      if (!mnav.classList.contains('open')) return;
      mnav.classList.remove('open'); d.body.classList.remove('cj-menu-open'); mnav.setAttribute('aria-hidden', 'true');
      root.style.removeProperty('--cj-lock');
      var sb = root.style.scrollBehavior; root.style.scrollBehavior = 'auto';
      w.scrollTo(0, lockY);
      root.style.scrollBehavior = sb;
    };
    $$('[data-menu-open]').forEach(function (b) { on(b, 'click', open); });
    $$('[data-menu-close]', mnav).forEach(function (b) { on(b, 'click', close); });
    on(d, 'keydown', function (e) { if (e.key === 'Escape') close(); });
    $$('[data-menu-sub]', mnav).forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        var subs = b.nextElementSibling;
        var isOpen = b.classList.toggle('open');
        if (subs) subs.classList.toggle('open', isOpen);
      });
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in w) || reduce) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- tile hover photos: only fetched on devices that can hover (saves ~250 KB on phones) ---------- */
  function initTileHover() {
    if (!w.matchMedia('(hover: hover)').matches) return;
    var go = function () { $$('.tile__img--hover[data-src]').forEach(function (i) { i.src = i.getAttribute('data-src'); i.removeAttribute('data-src'); }); };
    if ('requestIdleCallback' in w) w.requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 1200);
  }

  /* ---------- staggered reveal: [data-stagger] children fade-up one by one ---------- */
  function initStagger() {
    var els = $$('[data-stagger]');
    if (!els.length) return;
    var kids = function (c) { return $$(':scope > *', c); };
    var show = function (c) {
      kids(c).forEach(function (k, i) { k.style.transitionDelay = Math.min(i, 9) * 70 + 'ms'; });
      c.classList.add('in');
      setTimeout(function () { c.removeAttribute('data-stagger'); kids(c).forEach(function (k) { k.style.transitionDelay = ''; }); }, 1500);
    };
    if (!('IntersectionObserver' in w) || reduce) { els.forEach(function (c) { c.removeAttribute('data-stagger'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.05, rootMargin: '0px 0px -4% 0px' });
    els.forEach(function (c) { io.observe(c); });
  }

  /* ---------- hero / about videos ----------
     Videos with data-src load only after the page has finished loading (the poster image stays the LCP element);
     below-the-fold ones wait until they are near the viewport. Skipped on Save-Data / 2G and for reduced motion. */
  function initVideos() {
    var vids = Array.prototype.slice.call($$('.hero__video video, .about__video video, .vid2__media video'));
    if (!vids.length) return;
    var conn = navigator.connection || {};
    var lite = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
    var calm = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var start = function (v) {
      if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); // v5.9: poster only when the loop is about to play
      if (v.dataset.src && !v.getAttribute('src')) {
        var fast = !conn.effectiveType || conn.effectiveType === '4g';
        v.src = (v.dataset.srcHd && fast && w.innerWidth >= 750) ? v.dataset.srcHd : v.dataset.src;
      }
      var wrap = v.closest('.hero__video');
      var ready = function () { if (wrap) wrap.classList.add('ready'); };
      if (v.readyState >= 2) ready(); else { on(v, 'loadeddata', ready); on(v, 'canplay', ready); }
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
    };
    var afterLoad = function (fn) {
      var go = function () { (w.requestIdleCallback || function (f) { setTimeout(f, 300); })(fn, { timeout: 2500 }); };
      if (d.readyState === 'complete') go(); else on(w, 'load', go);
    };
    vids.forEach(function (v) {
      if (!v.dataset.src) { start(v); return; }
      if (lite || calm) return;
      if (v.closest('.hero__video') || !('IntersectionObserver' in w)) { afterLoad(function () { start(v); }); return; }
      afterLoad(function () {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { io.disconnect(); start(v); }
        }, { rootMargin: '400px 0px' });
        io.observe(v);
      });
    });
  }

  /* ---------- countdown (deal of the week) ---------- */
  function initCountdowns() {
    var els = $$('[data-countdown]');
    if (!els.length) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      els.forEach(function (el) {
        var ends = Number(el.getAttribute('data-ends')) * 1000;
        var ms = Math.max(0, ends - Date.now());
        var v = { d: Math.floor(ms / 86400000), h: Math.floor(ms / 3600000) % 24, m: Math.floor(ms / 60000) % 60, s: Math.floor(ms / 1000) % 60 };
        ['d', 'h', 'm', 's'].forEach(function (k) { var b = $('[data-cd-' + k + ']', el); if (b) b.textContent = pad(v[k]); });
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- dispatch estimate (UK working days, Europe/London cutoff) ---------- */
  var BANK = ['2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28','2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28','2028-01-03'];
  var pad2 = function (n) { return String(n).padStart(2, '0'); };
  function londonParts(now) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    var p = {};
    f.formatToParts(now).forEach(function (x) { if (x.type !== 'literal') p[x.type] = Number(x.value); });
    var hh = p.hour === 24 ? 0 : p.hour;
    return { y: p.year, m: p.month, d: p.day, hh: hh, mm: p.minute, ss: p.second, key: p.year + '-' + pad2(p.month) + '-' + pad2(p.day) };
  }
  var toNoon = function (key) { var a = key.split('-').map(Number); return new Date(Date.UTC(a[0], a[1] - 1, a[2], 12)); };
  var fromD = function (dt) { return dt.getUTCFullYear() + '-' + pad2(dt.getUTCMonth() + 1) + '-' + pad2(dt.getUTCDate()); };
  var wday = function (key) { return toNoon(key).getUTCDay(); };
  var isWork = function (key) { var x = wday(key); return x !== 0 && x !== 6 && BANK.indexOf(key) < 0; };
  var addDays = function (key, n) { var dt = toNoon(key); dt.setUTCDate(dt.getUTCDate() + n); return fromD(dt); };
  var addWork = function (key, n) { var k = key, left = n; while (left > 0) { k = addDays(k, 1); if (isWork(k)) left--; } return k; };
  function estimate(cutoff) {
    var now = new Date(), L = londonParts(now);
    var m = /^(\d{1,2})[:.](\d{2})$/.exec(String(cutoff || '').trim());
    var c = m ? { h: Number(m[1]), m: Number(m[2]) } : { h: 14, m: 0 };
    var before = L.hh < c.h || (L.hh === c.h && L.mm < c.m);
    var sameDay = isWork(L.key) && before;
    var msTo = 0;
    if (sameDay) {
      var nowSec = L.hh * 3600 + L.mm * 60 + L.ss;
      msTo = ((c.h * 3600 + c.m * 60) - nowSec) * 1000;
    }
    var dispatch = sameDay ? L.key : (isWork(L.key) && !before ? addWork(L.key, 1) : addWork(L.key, 1));
    if (!isWork(L.key)) dispatch = addWork(L.key, 1);
    return { sameDay: sameDay, msTo: msTo, dispatch: dispatch, from: addWork(dispatch, 2), to: addWork(dispatch, 3), express: addWork(dispatch, 1) };
  }
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function fmtDay(key, rel) {
    var L = londonParts(new Date());
    if (rel && key === L.key) return 'today';
    if (rel && key === addDays(L.key, 1)) return 'tomorrow';
    var dt = toNoon(key);
    return DAYS[dt.getUTCDay()] + ' ' + dt.getUTCDate() + ' ' + MONTHS[dt.getUTCMonth()];
  }
  function fmtRange(a, b) {
    var da = toNoon(a), db = toNoon(b);
    if (da.getUTCMonth() === db.getUTCMonth()) return DAYS[da.getUTCDay()] + ' ' + da.getUTCDate() + ' – ' + DAYS[db.getUTCDay()] + ' ' + db.getUTCDate() + ' ' + MONTHS[db.getUTCMonth()];
    return fmtDay(a) + ' – ' + fmtDay(b);
  }
  function fmtCd(ms) { var h = Math.floor(ms / 3600000), m = Math.ceil((ms % 3600000) / 60000); if (m === 60) { h++; m = 0; } return h > 0 ? h + 'h ' + pad2(m) + 'm' : m + ' min'; }
  function initDispatch() {
    var els = $$('[data-dispatch]');
    if (!els.length) return;
    var tick = function () {
      els.forEach(function (el) {
        var e = estimate(el.getAttribute('data-cutoff') || '14:00');
        var std = $('[data-dsp-std]', el), ex = $('[data-dsp-express]', el);
        if (std) {
          std.innerHTML = e.sameDay
            ? 'Order within <b class="dsp__cd">' + fmtCd(e.msTo) + '</b> — dispatched today, delivered <b>' + fmtRange(e.from, e.to) + '</b>'
            : 'Order now — dispatched <b>' + fmtDay(e.dispatch, true) + '</b>, delivered <b>' + fmtRange(e.from, e.to) + '</b>';
        }
        if (ex) {
          var label = ex.getAttribute('data-label') || 'Express next-day', price = ex.getAttribute('data-price') || '';
          ex.innerHTML = label + ' — your order jumps the queue' + (price ? ' · ' + price : '');
        }
        el.classList.add('is-ready');
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- cart helpers (Dawn cart-drawer) ---------- */
  function addToCart(variantId, qty, btn) {
    var drawer = $('cart-drawer');
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', qty || 1);
    if (drawer && drawer.getSectionsToRender) {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', w.location.pathname);
    }
    return fetch((w.routes && w.routes.cart_add_url) || '/cart/add', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Could not add to basket');
        if (drawer && drawer.renderContents) { drawer.renderContents(res); }
        else { w.location.href = (w.routes && w.routes.cart_url) || '/cart'; }
        return res;
      });
  }

  /* ---------- v5.8: boxes that act as links (product cards, deal of the week) — the real <a> is on the name, so anchor texts stay short ---------- */
  function initHrefBoxes() {
    $$('[data-href]').forEach(function (box) {
      if (box.dataset.cjHref || box.tagName === 'A') return;
      box.dataset.cjHref = '1';
      var go = function (e, newTab) {
        if (e.defaultPrevented) return;
        if (e.target && e.target.closest && e.target.closest('a, button, input, select, textarea, label, summary, video')) return;
        var h = box.getAttribute('data-href'); if (!h) return;
        if (newTab || e.metaKey || e.ctrlKey || e.shiftKey) { w.open(h, '_blank'); return; }
        w.location.href = h;
      };
      on(box, 'click', function (e) { if (e.button === 0) go(e, false); });
      on(box, 'auxclick', function (e) { if (e.button === 1) { e.preventDefault(); go(e, true); } });
    });
  }

  /* ---------- product cards ---------- */
  function initCards() {
    $$('.pc').forEach(function (card) {
      if (card.dataset.cjInit) return;
      card.dataset.cjInit = '1';
      var media = $('.pc__media', card);
      var link = $('.pc__link', card);
      var baseHref = card.getAttribute('data-href') || card.getAttribute('href') || (link && link.getAttribute('href'));
      var setHref = function (h) { // v5.8: the card is an <article data-href>; the real <a> sits on the name
        if (!h) return;
        if (card.tagName === 'A') card.setAttribute('href', h); else card.setAttribute('data-href', h);
        if (link) link.setAttribute('href', h);
      };
      var pick = function (dot) {
        var img = dot.getAttribute('data-img');
        var vid = dot.getAttribute('data-variant');
        $$('.pc__dot', card).forEach(function (x) { x.classList.toggle('cur', x === dot); });
        $$('.pc__img2', media).forEach(function (x) { x.classList.remove('on'); });
        if (img) {
          var el = $('.pc__img2[data-src="' + img + '"]', media);
          if (!el) {
            el = d.createElement('img');
            el.className = 'pc__img pc__img2'; el.alt = ''; el.setAttribute('aria-hidden', 'true');
            el.src = img; el.setAttribute('data-src', img);
            media.appendChild(el);
          }
          el.classList.add('on');
          card.classList.add('pc--pick');
        }
        if (vid && baseHref) setHref(baseHref.split('#')[0].split('?')[0] + '#variant=' + vid);
        var quick = $('.pc__quick', card);
        if (quick && vid) {
          var soldOut = dot.classList.contains('off');
          quick.disabled = soldOut;
          quick.classList.toggle('pc__quick--off', soldOut);
          if (!soldOut) quick.setAttribute('data-variant', vid);
        }
      };
      var quick0 = $('.pc__quick', card);
      var quickVid0 = quick0 ? quick0.getAttribute('data-variant') : null;
      $$('.pc__dot', card).forEach(function (dot) {
        on(dot, 'mouseenter', function () { pick(dot); });
        on(dot, 'focus', function () { pick(dot); });
        on(dot, 'click', function (e) { e.preventDefault(); e.stopPropagation(); pick(dot); });
      });
      on(card, 'mouseleave', function () {
        card.classList.remove('pc--pick');
        $$('.pc__img2', media).forEach(function (x) { x.classList.remove('on'); });
        var cur = card.getAttribute('data-current-variant');
        $$('.pc__dot', card).forEach(function (x) { x.classList.toggle('cur', x.getAttribute('data-variant') === cur); });
        if (baseHref) setHref(baseHref);
        if (quick0) { quick0.disabled = false; quick0.classList.remove('pc__quick--off'); quick0.setAttribute('data-variant', quickVid0); }
      });
      var quick = $('.pc__quick', card);
      if (quick) {
        on(quick, 'click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var vid = quick.getAttribute('data-variant');
          if (!vid || quick.disabled) return;
          var label = quick.innerHTML;
          quick.classList.add('pc__quick--done');
          quick.innerHTML = 'Added <i class="ti ti-check" aria-hidden="true"></i>';
          addToCart(vid, 1).catch(function (err) { alert(err.message); });
          setTimeout(function () { quick.classList.remove('pc__quick--done'); quick.innerHTML = label; }, 1500);
        });
      }
    });
  }

  /* ---------- favourites (localStorage) ---------- */
  var FAV_KEY = 'cj_favs';
  var favs = function () { return ls.get(FAV_KEY) || []; };
  function favCount() {
    var n = favs().length;
    $$('[data-fav-count]').forEach(function (b) { b.textContent = n ? String(n) : ''; b.setAttribute('data-count', String(n)); });
  }
  function initFavs() {
    var list = favs();
    $$('[data-fav]').forEach(function (b) {
      var h = b.getAttribute('data-fav');
      b.classList.toggle('on', list.indexOf(h) >= 0);
      if (b.dataset.cjInit) return;
      b.dataset.cjInit = '1';
      on(b, 'click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var cur = favs(), i = cur.indexOf(h);
        if (i >= 0) cur.splice(i, 1); else cur.unshift(h);
        ls.set(FAV_KEY, cur.slice(0, 60));
        $$('[data-fav="' + h + '"]').forEach(function (x) { x.classList.toggle('on', i < 0); });
        favCount();
      });
    });
    favCount();
  }

  /* ---------- product JSON → card (favourites page, recently viewed) ---------- */
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  /* Deal of the week for these JSON cards. Source of truth stays snippets/catjoy-deal.liquid: the handle comes from
     the deal section, % and price mode from the product section (the same data-deal-* the PDP reads), fetched only
     when a listed product could be on deal. If theme.liquid ever sets catjoy.dealHandle/dealPercent/dealMode, those win. */
  var NO_DEAL = { handle: '', pct: 0, mode: '' };
  var dealHandleP = null, dealInfoP = null;
  var parseHtml = function (html) { return new DOMParser().parseFromString(html || '', 'text/html'); };
  var dealCents = function (p, cents, deal) { return deal && deal.pct > 0 && deal.mode === 'visual' && p.handle === deal.handle ? Math.floor(cents * (100 - deal.pct) / 100) : cents; };
  function dealFor(handles) {
    if (typeof CFG.dealHandle === 'string') return Promise.resolve({ handle: CFG.dealHandle, pct: Number(CFG.dealPercent || 0), mode: CFG.dealMode || 'visual' });
    if (!dealHandleP) dealHandleP = fetch('/?sections=catjoy-deal-week')
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) { var a = parseHtml(j['catjoy-deal-week']).querySelector('.offer--deal[data-href], a.offer--deal[href]'); var m = a && /\/products\/([^\/?#]+)/.exec(a.getAttribute('data-href') || a.getAttribute('href')); return m ? decodeURIComponent(m[1]) : ''; })
      .catch(function () { return ''; });
    return dealHandleP.then(function (h) {
      if (!h || handles.indexOf(h) < 0) return NO_DEAL;
      if (!dealInfoP) dealInfoP = fetch('/products/' + h + '?sections=catjoy-product')
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (j) { var el = parseHtml(j['catjoy-product']).querySelector('[data-deal-percent]'); return el ? { handle: h, pct: Number(el.getAttribute('data-deal-percent')) || 0, mode: el.getAttribute('data-deal-mode') || 'visual' } : NO_DEAL; })
        .catch(function () { return NO_DEAL; });
      return dealInfoP;
    });
  }
  function jsonCard(p, deal) {
    var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
    var v = p.variants && p.variants[0];
    var price = v ? v.price : p.price, cmp = v ? v.compare_at_price : p.compare_at_price;
    var isDeal = !!(deal && deal.pct > 0 && p.handle === deal.handle);
    if (isDeal && deal.mode === 'visual') { if (!(cmp > price)) cmp = price; price = dealCents(p, price, deal); } // was = original compare-at, else regular price
    var save = cmp && cmp > price ? cmp - price : 0;
    var disc = save ? Math.round((1 - price / cmp) * 100) : 0;
    var pct = Number(CFG.clubPercent || 0);
    var bonus = pct ? Math.round(price * pct / 100) : 0;
    return '<article class="pc" data-href="/products/' + esc(p.handle) + '">' +
      '<div class="pc__media">' + (img ? '<img class="pc__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<div class="pc__noimg"><i class="ti ti-paw"></i></div>') +
      '<div class="pc__badges">' + (isDeal ? '<span class="pc__badge pc__badge--deal">Deal<span class="pc__badge-x"> of the week</span>' + (disc ? ' −' + disc + '%' : '') + '</span>' : disc ? '<span class="pc__badge pc__badge--sale">−' + disc + '%</span>' : '') + '</div>' +
      '<button type="button" class="pc__fav" data-fav="' + esc(p.handle) + '" aria-label="Save to favourites"><i class="ti ti-heart"></i></button></div>' +
      '<div class="pc__body"><div class="pc__top"><span class="pc__brand">' + esc(CFG.shopName || 'Cat Joy') + '</span></div>' +
      '<div class="pc__name"><a class="pc__link" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a></div>' +
      '<div class="pc__row"><div class="pc__price">' + (save ? '<s>' + money(cmp) + '</s>' : '') + '<b>' + money(price) + '</b>' + (save ? '<span class="save-chip">Save ' + money(save) + '</span>' : '') + '</div></div>' +
      (bonus ? '<div class="pc__perks"><span class="pc__bonus"><i class="ti ti-coin" aria-hidden="true"></i><b>Earn ' + money(bonus) + '</b> <span class="pc__bonus-txt">Club cashback</span></span></div>' : '') +
      '</div></article>';
  }
  function renderHandles(container, handles, emptyHtml) {
    if (!container) return Promise.resolve([]);
    var list = handles.slice(0, Number(container.getAttribute('data-limit') || 8));
    if (!list.length) { if (emptyHtml) container.innerHTML = emptyHtml; else container.closest('[data-recent-wrap]') && (container.closest('[data-recent-wrap]').hidden = true); return Promise.resolve([]); }
    return Promise.all([Promise.all(list.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })), dealFor(list)])
      .then(function (res) {
        var ps = res[0].filter(Boolean), deal = res[1];
        if (!ps.length) { if (emptyHtml) container.innerHTML = emptyHtml; return; }
        ps.deal = deal;
        container.innerHTML = ps.map(function (p) { return jsonCard(p, deal); }).join('');
        var wrap = container.closest('[data-recent-wrap]'); if (wrap) wrap.hidden = false;
        initFavs(); initCards(); initHrefBoxes();
        return ps;
      });
  }
  function initFavPage() {
    var c = $('[data-favs-grid]');
    if (!c) return;
    renderHandles(c, favs(), '<div class="favs-empty"><i class="ti ti-heart"></i>No favourites yet — tap the heart on any scratcher.</div>');
  }
  var RECENT_KEY = 'cj_recent';
  function initRecent() {
    var pdp = $('[data-product-handle]');
    if (pdp) {
      var h = pdp.getAttribute('data-product-handle');
      var cur = (ls.get(RECENT_KEY) || []).filter(function (x) { return x !== h; });
      cur.unshift(h);
      ls.set(RECENT_KEY, cur.slice(0, 12));
    }
    var c = $('[data-recent-grid]');
    if (!c) return;
    var skip = c.getAttribute('data-skip');
    renderHandles(c, (ls.get(RECENT_KEY) || []).filter(function (x) { return x !== skip; }));
  }

  /* ---------- rail nudge ("Swipe" hint on phones) ---------- */
  function initRailNudge() {
    $$('[data-rail-nudge]').forEach(function (hint) {
      var rail = $(hint.getAttribute('data-rail-nudge'));
      if (!rail || !w.matchMedia('(max-width: 640px)').matches || !('IntersectionObserver' in w)) return;
      var done = false;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || done) return;
        done = true; io.disconnect();
        if (rail.scrollLeft > 8) return;
        hint.classList.add('on');
        if (!reduce) { setTimeout(function () { rail.scrollTo({ left: 72, behavior: 'smooth' }); }, 350); setTimeout(function () { rail.scrollTo({ left: 0, behavior: 'smooth' }); }, 1100); }
        setTimeout(function () { hint.classList.remove('on'); }, 3600);
      }, { threshold: 0.2 });
      io.observe(rail);
      on(rail, 'scroll', function () { if (rail.scrollLeft > 90) hint.classList.remove('on'); }, { passive: true });
    });
  }

  /* ---------- footer accordion (phones) ---------- */
  function initFooter() {
    $$('.ftr__acc-head').forEach(function (h) {
      on(h, 'click', function () {
        if (!w.matchMedia('(max-width: 640px)').matches) return;
        h.closest('.ftr__acc').classList.toggle('open');
      });
    });
  }

  /* ---------- collection sort ---------- */
  function initSort() {
    $$('[data-sort-select]').forEach(function (sel) {
      on(sel, 'change', function () {
        var u = new URL(w.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        w.location.href = u.toString();
      });
    });
  }

  /* ---------- PDP ---------- */
  function initPdp() {
    var pdp = $('[data-pdp]');
    if (!pdp || pdp.dataset.cjInit) return;
    pdp.dataset.cjInit = '1';
    var dataEl = $('[data-product-json]', pdp);
    var product = null;
    try { product = JSON.parse(dataEl.textContent); } catch (e) {}
    var form = $('form[data-type="add-to-cart-form"]', pdp) || $('form', pdp);
    var idInput = form ? $('input[name="id"]', form) : null;
    var qtyInput = $('[data-qty-input]', pdp);
    var clubPct = Number(pdp.getAttribute('data-club-percent') || 0);
    var dealPct = Number(pdp.getAttribute('data-deal-percent') || 0);
    var dealMode = pdp.getAttribute('data-deal-mode') || 'visual';

    // gallery
    var stage = $('.gal__stage', pdp), track = $('.gal__track', pdp);
    var slides = $$('.gal__slide', pdp), thumbs = $$('.gal__thumb', pdp), dots = $$('.gal__dots i', pdp);
    var cur = 0;
    var isMobile = function () { return w.matchMedia('(max-width: 960px)').matches; };
    function show(i, scroll) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var onIt = k === cur;
        s.classList.toggle('on', onIt);
        var v = $('video', s);
        if (v) { if (onIt) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('act', k === cur); });
      dots.forEach(function (t, k) { t.classList.toggle('on', k === cur); });
      var tint = slides[cur].getAttribute('data-tint');
      if (stage && tint) stage.style.setProperty('--tint', tint);
      if (scroll !== false && isMobile() && track) track.scrollTo({ left: slides[cur].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      var t = thumbs[cur]; if (t && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    }
    thumbs.forEach(function (t, k) { on(t, 'click', function () { show(k); }); });
    on($('.gal__arr--prev', pdp), 'click', function () { show(cur - 1); });
    on($('.gal__arr--next', pdp), 'click', function () { show(cur + 1); });
    if (track) {
      var st;
      on(track, 'scroll', function () {
        if (!isMobile()) return;
        clearTimeout(st);
        st = setTimeout(function () {
          var k = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (k !== cur) show(k, false);
        }, 80);
      }, { passive: true });
    }
    on(d, 'keydown', function (e) {
      if (lb && !lb.hidden) { if (e.key === 'ArrowLeft') show(cur - 1); if (e.key === 'ArrowRight') show(cur + 1); if (e.key === 'Escape') closeLb(); if (!lb.hidden) syncLb(); }
    });
    // lightbox
    var lb = $('.lb', pdp);
    function syncLb() {
      if (!lb) return;
      var s = slides[cur];
      var img = $('img', s), vid = $('video', s);
      var box = $('.lb__body', lb);
      box.innerHTML = '';
      if (vid) { var v = d.createElement('video'); v.className = 'lb__video'; v.src = vid.currentSrc || vid.src; v.controls = true; v.autoplay = true; v.loop = true; v.playsInline = true; v.muted = true; box.appendChild(v); }
      else if (img) { var im = d.createElement('img'); im.className = 'lb__img'; im.src = img.getAttribute('data-full') || img.src; im.alt = img.alt || ''; box.appendChild(im); }
      var cap = $('.lb__cap b', lb); if (cap) cap.textContent = (cur + 1) + ' / ' + slides.length;
    }
    function openLb() { if (!lb || !slides.length) return; syncLb(); lb.hidden = false; root.classList.add('cj-lb-open'); }
    function closeLb() { if (!lb) return; lb.hidden = true; root.classList.remove('cj-lb-open'); var v = $('video', lb); if (v) v.pause(); }
    on($('.gal__expand', pdp), 'click', openLb);
    slides.forEach(function (s) { on(s, 'click', function () { if (!isMobile() && !$('video', s)) openLb(); }); });
    if (lb) {
      on($('.lb__close', lb), 'click', closeLb);
      on(lb, 'click', function (e) { if (e.target === lb) closeLb(); });
      on($('.lb__arr--prev', lb), 'click', function () { show(cur - 1, false); syncLb(); });
      on($('.lb__arr--next', lb), 'click', function () { show(cur + 1, false); syncLb(); });
    }
    show(0, false);

    // variant selection (colour swatches)
    var swatches = $$('[data-variant-id]', pdp);
    function variantById(id) { return product && product.variants ? product.variants.filter(function (v) { return String(v.id) === String(id); })[0] : null; }
    function tintFor(name) {
      var n = String(name || '').toLowerCase();
      if (/white|cream|ivory|snow|light/.test(n)) return '#EEF6F1';
      if (/black|dark|charcoal|graphite|anthracite/.test(n)) return '#EDEBFA';
      return '#F4ECDF';
    }
    function applyVariant(v, push) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      swatches.forEach(function (s) { s.classList.toggle('act', String(s.getAttribute('data-variant-id')) === String(v.id)); s.setAttribute('aria-current', String(s.getAttribute('data-variant-id')) === String(v.id) ? 'true' : 'false'); });
      var colourName = v.option1 || '';
      colourName = colourName ? String(colourName).charAt(0).toUpperCase() + String(colourName).slice(1).toLowerCase() : colourName;
      var lab = $('[data-colour-name]', pdp); if (lab) lab.textContent = colourName;
      var tcol = $('[data-title-colour]', pdp); if (tcol) tcol.textContent = colourName ? ' — ' + colourName : '';
      // price
      var price = v.price, cmp = v.compare_at_price;
      var was = cmp && cmp > price ? cmp : null;
      if (dealPct && dealMode === 'visual') { was = was || price; price = Math.floor(price * (100 - dealPct) / 100); } // was = original compare-at, else regular price
      var pe = $('[data-price]', pdp); if (pe) pe.textContent = money(price);
      var we = $('[data-was]', pdp); if (we) { we.textContent = was ? money(was) : ''; we.hidden = !was; }
      var se = $('[data-save]', pdp); if (se) { var save = was ? was - price : 0; se.textContent = save ? 'Save ' + money(save) : ''; se.hidden = !save; }
      var be = $('[data-bonus]', pdp); if (be && clubPct) { be.textContent = money(Math.round(price * (Number(qtyInput && qtyInput.value) || 1) * clubPct / 100)); }
      var sku = $('[data-sku]', pdp); if (sku) { sku.textContent = v.sku ? 'SKU ' + v.sku : ''; }
      // availability
      var avail = v.available;
      var stock = $('[data-stock]', pdp);
      if (stock) stock.innerHTML = avail ? '<span class="instock"><i class="ti ti-circle-check"></i> In stock</span>' : '<span class="nostock">' + (colourName ? esc(colourName) + ' is sold out — pick another colour' : 'Out of stock') + '</span>';
      var btn = $('[data-add-btn]', pdp);
      if (btn) {
        var span = $('span', btn);
        if (avail) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); if (span) span.textContent = btn.getAttribute('data-label-add') || 'Add to basket'; }
        else { btn.setAttribute('disabled', 'disabled'); if (span) span.textContent = colourName ? colourName + ' is sold out' : 'Out of stock'; }
      }
      var pay = $('.shopify-payment-button', pdp); if (pay) pay.style.display = avail ? '' : 'none';
      var stickyBtn = $('.sticky-buy .btn', pdp); if (stickyBtn) stickyBtn.toggleAttribute('disabled', !avail);
      var sp = $('.sticky-buy .sp b', pdp); if (sp) sp.textContent = money(price);
      var ss = $('.sticky-buy .sp small', pdp); if (ss && product) ss.textContent = String(product.title).replace(/ — (?!premium )/i, ' — Premium ') + (colourName ? ' · ' + colourName : ''); // type line starts with "Premium", as in the H1
      // gallery → variant image
      if (v.featured_media && v.featured_media.id) {
        var k = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(v.featured_media.id); });
        if (k >= 0) show(k, true);
      }
      var spic = $('.sticky-buy__pic img', pdp);
      if (spic && v.featured_image) spic.src = (v.featured_image.src || v.featured_image);
      if (stage && !v.featured_media) stage.style.setProperty('--tint', tintFor(colourName));
      var spw = $('.sticky-buy__pic', pdp); if (spw) spw.style.setProperty('--tint', tintFor(colourName));
      if (push && w.history && w.history.replaceState) { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState({}, '', u.toString()); }
    }
    swatches.forEach(function (s) {
      on(s, 'click', function (e) { e.preventDefault(); applyVariant(variantById(s.getAttribute('data-variant-id')), true); });
    });
    // v5.8: cards link with #variant=ID (a fragment, not a URL parameter) — apply that colour on load
    var hashV = /[#&]variant=(\d+)/.exec(w.location.hash || '');
    var startV = hashV ? variantById(hashV[1]) : null;
    if (idInput && product) applyVariant(startV || variantById(idInput.value), false);
    d.documentElement.classList.remove('cj-hv');

    // quantity
    if (qtyInput) {
      var max = Number(qtyInput.getAttribute('max') || 10);
      var setQ = function (n) { n = Math.max(1, Math.min(max, n)); qtyInput.value = n; var be = $('[data-bonus]', pdp); var v = variantById(idInput && idInput.value); if (be && clubPct && v) { var price = dealPct && dealMode === 'visual' ? Math.floor(v.price * (100 - dealPct) / 100) : v.price; be.textContent = money(Math.round(price * n * clubPct / 100)); } };
      on($('[data-qty-minus]', pdp), 'click', function () { setQ(Number(qtyInput.value) - 1); });
      on($('[data-qty-plus]', pdp), 'click', function () { setQ(Number(qtyInput.value) + 1); });
      on(qtyInput, 'change', function () { setQ(Number(qtyInput.value) || 1); });
    }
    // sticky bar → submit the real form
    on($('[data-sticky-add]', pdp), 'click', function () {
      var btn = $('[data-add-btn]', pdp);
      if (btn && !btn.disabled) btn.click();
    });
  }

  /* ---------- chat paw ---------- */
  function initFab() {
    var fab = $('.cfab');
    if (!fab) return;
    var main = $('.tgfab', fab), stack = $('.cfab__stack', fab), hint = $('.tgfab__hint', fab);
    var setOpen = function (o) { fab.classList.toggle('open', o); if (stack) stack.hidden = !o; root.classList.toggle('cj-fab-open', o); main.setAttribute('aria-expanded', o ? 'true' : 'false'); if (hint) hint.hidden = true; };
    on(main, 'click', function () { setOpen(!fab.classList.contains('open')); });
    on(d, 'keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    on(d, 'pointerdown', function (e) { if (fab.classList.contains('open') && !fab.contains(e.target)) setOpen(false); });
    $$('.cfab__opt', fab).forEach(function (a, i, arr) { a.style.setProperty('--i', String(arr.length - 1 - i)); on(a, 'click', function () { setOpen(false); }); });
    if (hint) {
      try { if (sessionStorage.getItem('cj_chat_hint')) return; } catch (e) {}
      setTimeout(function () {
        if (fab.classList.contains('open')) return;
        hint.hidden = false;
        try { sessionStorage.setItem('cj_chat_hint', '1'); } catch (e) {}
        setTimeout(function () { hint.hidden = true; }, 6000);
      }, 8000);
    }
  }

  /* ---------- back to top ---------- */
  function initToTop() {
    var b = $('.totop');
    if (!b) return;
    var f = function () { b.classList.toggle('on', w.scrollY > 700); };
    f(); on(w, 'scroll', f, { passive: true });
    on(b, 'click', function () { w.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
  }

  /* ---------- paw trail (desktop, fine pointer) ---------- */
  function initPawTrail() {
    if (!CFG.pawTrail) return;
    if (!w.matchMedia('(pointer: fine)').matches || reduce || w.innerWidth < 1024) return;
    var PAW = function (fill) { return 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><g fill="' + fill + '"><ellipse cx="14" cy="24" rx="7" ry="9.5" transform="rotate(-18 14 24)"/><ellipse cx="26" cy="13" rx="7" ry="10" transform="rotate(-6 26 13)"/><ellipse cx="40" cy="13" rx="7" ry="10" transform="rotate(6 40 13)"/><ellipse cx="51" cy="24" rx="7" ry="9.5" transform="rotate(18 51 24)"/><path d="M32 27c9 0 17 7 19 15 2 8-3 14-11 15-3 .4-6-1-8-3-2 2-5 3.4-8 3-8-1-13-7-11-15 2-8 10-15 19-15z"/></g></svg>'); };
    var DARK = '.hero__card, .hero__media, .marq, footer.ftr, .offer, .nl__in, .why__tile:first-child, .mnav__panel, .hdr__pill, .btn-b, .promo-tile:first-child, .tile, .mega__promo, .size-rule, .club__tier.cur';
    var layer = d.createElement('div'); layer.id = 'paw-layer'; layer.setAttribute('aria-hidden', 'true'); d.body.appendChild(layer);
    var dark = PAW('#FFFDF8'), ink = PAW('#0F3D36');
    var lastX = -999, lastY = -999, lastT = 0, step = 0;
    on(d, 'mousemove', function (e) {
      var now = performance.now(), dx = e.clientX - lastX, dy = e.clientY - lastY, dist = Math.hypot(dx, dy);
      if (dist < 46 || now - lastT < 80) return;
      lastT = now;
      var angle = (Math.atan2(dy, dx) * 180) / Math.PI + 90;
      lastX = e.clientX; lastY = e.clientY;
      var side = step % 2 === 0 ? -1 : 1; step++;
      var nx = dist ? -dy / dist : 0, ny = dist ? dx / dist : 0;
      var x = e.clientX + nx * side * 9, y = e.clientY + ny * side * 9;
      var under = d.elementFromPoint(e.clientX, e.clientY);
      var onDark = Boolean(under && under.closest(DARK));
      var el = d.createElement('i'); el.className = 'paw-print';
      var size = 17 + Math.random() * 8;
      el.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + size + 'px;--rot:' + (angle + side * 12) + 'deg;background-image:url("' + (onDark ? dark : ink) + '")';
      layer.appendChild(el);
      setTimeout(function () { el.remove(); }, 1800);
    }, { passive: true });
  }

  /* ---------- welcome popup ---------- */
  function initWelcome() {
    var wo = $('.wo[data-welcome]');
    if (!wo) return;
    var KEY = 'cj_welcome';
    var delay = Number(wo.getAttribute('data-delay') || 8);
    var force = /[?&]welcome=now/.test(w.location.search);
    var mobile = w.matchMedia('(max-width: 640px)').matches;
    var excluded = /^\/(cart|checkout|account|challenge)/.test(w.location.pathname) || /customer_posted=true/.test(w.location.search);
    var seen = ls.raw(KEY) || '';
    var seenAt = /^seen:(\d+)$/.test(seen) ? Number(seen.slice(5)) : (seen ? Date.now() : 0);
    var fresh = seen === 'subscribed' || (seen && Date.now() - seenAt < 30 * 864e5);
    if (!force && (fresh || excluded || wo.getAttribute('data-signed-in') === 'true')) return;
    var done = false, armedAt = Date.now(), timer = 0;
    var card = $('.wo__card', wo), input = $('input[type="email"]', wo);
    var open = function () {
      if (done) return; done = true;
      wo.hidden = false; root.classList.add('cj-welcome-open');
      if (!force) ls.put(KEY, 'seen:' + Date.now());
      setTimeout(function () { (mobile ? card : input) && (mobile ? card : input).focus(); }, 80);
      cleanup();
    };
    var close = function () { wo.hidden = true; root.classList.remove('cj-welcome-open'); };
    var onExit = function (e) { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - armedAt > 2500) open(); };
    var onScroll = function () { var max = root.scrollHeight - w.innerHeight; if (max > 0 && w.scrollY / max >= 0.4) open(); };
    var cleanup = function () { clearTimeout(timer); d.removeEventListener('mouseout', onExit); w.removeEventListener('scroll', onScroll); };
    // v5.8: the timer starts only after the first interaction (scroll / touch / mouse / key) — until then
    // the popup never becomes the page's largest element, so LCP stays with the hero (Lighthouse never interacts)
    var arm = function () { if (!timer) timer = setTimeout(open, (force ? 0 : delay + (mobile ? 4 : 0)) * 1000); };
    if (force) arm(); else ['scroll', 'touchstart', 'pointerdown', 'mousemove', 'keydown'].forEach(function (ev) { w.addEventListener(ev, arm, { once: true, passive: true }); });
    if (mobile) on(w, 'scroll', onScroll, { passive: true }); else on(d, 'mouseout', onExit);
    $$('[data-wo-close]', wo).forEach(function (b) { on(b, 'click', close); });
    on(wo, 'click', function (e) { if (e.target === wo) close(); });
    on(d, 'keydown', function (e) { if (e.key === 'Escape' && !wo.hidden) close(); });
    // swipe the banner down to close (phones)
    var ty = null, media = $('.wo__media', wo);
    on(media, 'touchstart', function (e) { ty = e.touches[0] ? e.touches[0].clientY : null; }, { passive: true });
    on(media, 'touchmove', function (e) { var y = e.touches[0] && e.touches[0].clientY; if (ty !== null && typeof y === 'number' && y - ty > 90) { ty = null; close(); } }, { passive: true });
    // submit: Shopify customer form (newsletter tag) via fetch, then show the code
    var form = $('form', wo);
    on(form, 'submit', function (e) {
      var addr = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { e.preventDefault(); var er = $('.wo__err', wo); er.hidden = false; er.textContent = 'Please check your email address'; input.focus(); return; }
      e.preventDefault();
      var btn = $('.wo__btn', form); btn.disabled = true;
      var fd = new FormData(form);
      fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'follow' })
        .then(function (r) {
          if (/challenge/.test(r.url)) { form.submit(); return; }
          $('.wo__form-view', wo).hidden = true;
          $('.wo__ok', wo).hidden = false;
          ls.put(KEY, 'subscribed');
        })
        .catch(function () { form.submit(); })
        .finally(function () { btn.disabled = false; });
    });
    on($('[data-wo-copy]', wo), 'click', function (b) {
      var code = $('.wo__code code', wo); if (!code) return;
      var btn = b.currentTarget;
      try { navigator.clipboard.writeText(code.textContent).then(function () { btn.innerHTML = '<i class="ti ti-check" aria-hidden="true"></i> Copied'; setTimeout(function () { btn.innerHTML = '<i class="ti ti-copy" aria-hidden="true"></i> Copy'; }, 2000); }); } catch (err) {}
    });
  }

  /* ---------- newsletter success anchor ---------- */
  function initNewsletter() {
    if (/customer_posted=true/.test(w.location.search)) {
      var ok = $('.nl__ok') || $('#contact_form');
      if (ok && ok.scrollIntoView) setTimeout(function () { ok.scrollIntoView({ block: 'center' }); }, 100);
    }
  }


  /* ---------- Find my size (quiz) — same three questions as new.catjoy.uk ---------- */
  function initQuiz() {
    var root = $('[data-quiz]');
    if (!root || root.dataset.cjInit) return;
    root.dataset.cjInit = '1';
    var models = {}, T = {};
    try { models = JSON.parse(root.getAttribute('data-models') || '{}'); } catch (e) {}
    try { T = JSON.parse(root.getAttribute('data-i18n') || '{}'); } catch (e) {}
    var TOTAL = 3, step = 0;
    var ans = { cats: null, weight: null, place: null };
    var panes = $$('[data-quiz-pane]', root);
    var nav = $('[data-quiz-nav]', root), result = $('[data-quiz-result]', root);
    var prog = $('.quiz__prog i', root), stepEl = $('[data-quiz-step]', root);
    var backBtn = $('[data-quiz-back]', root), nextBtn = $('[data-quiz-next]', root);
    var nextLbl = $('[data-quiz-next-label]', root), grid = $('[data-quiz-grid]', root);
    var addBtn = $('[data-quiz-add]', root), addLbl = $('[data-quiz-add-label]', root);
    var mainVariant = null;
    var KEYS = ['cats', 'weight', 'place'];

    function draw() {
      panes.forEach(function (p) { p.hidden = step >= TOTAL || Number(p.getAttribute('data-quiz-pane')) !== step; });
      if (nav) nav.hidden = step >= TOTAL;
      if (result) result.hidden = step < TOTAL;
      if (prog) prog.style.width = Math.min(100, (step / TOTAL) * 100) + '%';
      if (stepEl) stepEl.textContent = step < TOTAL ? String(T.step || 'Question _n_ of 3').replace('_n_', step + 1) : (T.done || 'Done');
      if (backBtn) backBtn.hidden = step === 0;
      if (nextLbl) nextLbl.textContent = step === TOTAL - 1 ? (T.show || 'Show my match') : (T.next || 'Next');
      if (nextBtn) nextBtn.disabled = !ans[KEYS[step]];
    }

    function recommend() {
      if (ans.cats === '2+') return { main: 'penthouse', alt: 'mews', why: T.why_two };
      if (ans.weight === 'large') return { main: 'mews', alt: 'penthouse', why: T.why_large };
      if (ans.place === 'house') return { main: 'mews', alt: 'terrace', why: T.why_house };
      if (ans.place === 'windowsill') return { main: 'lounge', alt: 'snug', why: T.why_window };
      if (ans.weight === 'medium') return { main: 'terrace', alt: 'pavilion', why: T.why_medium };
      return { main: 'snug', alt: 'lounge', why: T.why_default };
    }

    var shortName = function (t) { return String(t || '').split(' — ')[0].split(' - ')[0]; };
    var lengthOf = function (t) { var m = String(t || '').match(/(\d+)\s*cm/i); return m ? m[1] + ' cm' : ''; };

    function show() {
      var r = recommend();
      var handles = [models[r.main], models[r.alt]].filter(Boolean);
      var why = $('[data-quiz-why]', root); if (why) why.textContent = r.why || '';
      renderHandles(grid, handles, '<div class="favs-empty"><i class="ti ti-paw-off" aria-hidden="true"></i>' + (T.empty || '') + '</div>')
        .then(function (ps) {
          if (!ps || !ps.length) return;
          Array.prototype.slice.call(grid.children).forEach(function (el, i) {
            if (el.classList.contains('quiz__pick')) return;
            var wrap = d.createElement('div'); wrap.className = 'quiz__pick';
            var lbl = d.createElement('span'); lbl.className = 'quiz__pick-lbl' + (i === 0 ? ' main' : '');
            lbl.textContent = i === 0 ? (T.our_pick || 'Our pick') : (T.also_great || 'Also great');
            grid.insertBefore(wrap, el); wrap.appendChild(lbl); wrap.appendChild(el);
          });
          var p = ps[0];
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
          mainVariant = v ? v.id : null;
          var price = dealCents(p, v ? v.price : p.price, ps.deal);
          var h1 = $('[data-quiz-title]', root);
          if (h1) h1.textContent = String(T.result_for || 'Your match').replace('_t_', shortName(p.title));
          var size = $('[data-quiz-size]', root); if (size) size.textContent = lengthOf(p.title) || shortName(p.title);
          var pr = $('[data-quiz-price]', root); if (pr) pr.textContent = money(price);
          if (addBtn && mainVariant) {
            addBtn.hidden = false;
            if (addLbl) addLbl.textContent = String(T.add || 'Add to basket').replace('_t_', shortName(p.title)).replace('_p_', money(price));
          }
        });
      if (w.catjoyTrack) w.catjoyTrack('quiz_complete', r);
    }

    $$('.quiz__opt', root).forEach(function (b) {
      on(b, 'click', function () {
        var q = b.getAttribute('data-q');
        ans[q] = b.getAttribute('data-v');
        $$('.quiz__opt[data-q="' + q + '"]', root).forEach(function (x) { x.classList.toggle('on', x === b); });
        draw();
      });
    });
    if (nextBtn) on(nextBtn, 'click', function () { if (!ans[KEYS[step]]) return; step++; draw(); if (step >= TOTAL) { show(); root.scrollIntoView({ block: 'start', behavior: 'smooth' }); } });
    if (backBtn) on(backBtn, 'click', function () { if (step > 0) { step--; draw(); } });
    var restart = $('[data-quiz-restart]', root);
    if (restart) on(restart, 'click', function () {
      step = 0; ans = { cats: null, weight: null, place: null };
      $$('.quiz__opt', root).forEach(function (x) { x.classList.remove('on'); });
      if (grid) grid.innerHTML = '';
      if (addBtn) addBtn.hidden = true;
      draw(); root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    if (addBtn) on(addBtn, 'click', function () {
      if (!mainVariant) return;
      addBtn.classList.add('is-busy');
      addToCart(mainVariant, 1, addBtn).catch(function () {}).then(function () { addBtn.classList.remove('is-busy'); });
    });
    // the customer form came back with ?customer_posted=true → show the code instead of the field
    if (/customer_posted=true/.test(w.location.search)) {
      var f = $('[data-quiz-form]', root), c = $('[data-quiz-code]', root);
      if (f) f.hidden = true;
      if (c) c.hidden = false;
    }
    draw();
  }


  /* ---------- customer review photos: one lightbox for the strip and the per-review thumbs ---------- */
  function initRevPix() {
    var list = $('[data-revlist]');
    var lb = $('[data-revlb]');
    if (!list || !lb || list.dataset.cjInit) return;
    list.dataset.cjInit = '1';
    // the strip and the thumbs share one ordered set of photos
    var strip = $$('.revpix__cell', list);
    var srcs = strip.map(function (b) { return b.getAttribute('data-full'); });
    if (!srcs.length) srcs = $$('.revthumbs__cell', list).map(function (b) { return b.getAttribute('data-full'); });
    var cur = 0;
    function draw() {
      var box = $('.lb__body', lb);
      if (!box) return;
      box.innerHTML = '';
      var im = d.createElement('img');
      im.className = 'lb__img'; im.src = srcs[cur]; im.alt = '';
      box.appendChild(im);
      var cap = $('.lb__cap b', lb); if (cap) cap.textContent = (cur + 1) + ' / ' + srcs.length;
    }
    function open(i) { cur = (i + srcs.length) % srcs.length; draw(); lb.hidden = false; d.documentElement.classList.add('cj-lb-open'); }
    function close() { lb.hidden = true; d.documentElement.classList.remove('cj-lb-open'); }
    $$('[data-revpix]', list).forEach(function (b) {
      on(b, 'click', function () { open(Number(b.getAttribute('data-revpix')) || 0); });
    });
    on($('.lb__close', lb), 'click', close);
    on($('.lb__arr--prev', lb), 'click', function () { open(cur - 1); });
    on($('.lb__arr--next', lb), 'click', function () { open(cur + 1); });
    on(lb, 'click', function (e) { if (e.target === lb) close(); });
    on(d, 'keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') open(cur - 1);
      if (e.key === 'ArrowRight') open(cur + 1);
    });
  }

  function init() {
    initHeader(); initReveal(); initStagger(); initTileHover(); initVideos(); initCountdowns(); initDispatch();
    initHrefBoxes(); initCards(); initFavs(); initFavPage(); initRecent(); initRailNudge(); initFooter(); initSort();
    initPdp(); initFab(); initToTop(); initPawTrail(); initWelcome(); initNewsletter(); initQuiz(); initRevPix();
  }
  if (d.readyState === 'loading') on(d, 'DOMContentLoaded', init); else init();
  // theme editor: re-run light inits when a section is (re)loaded
  on(d, 'shopify:section:load', function () { initReveal(); initStagger(); initVideos(); initCountdowns(); initDispatch(); initCards(); initHrefBoxes(); initFavs(); initPdp(); initFooter(); });
  w.catjoyAddToCart = addToCart;
})();


/* Buy now: add the selected variant, then straight to checkout (keeps our coral button instead of Shop Pay branding) */
document.addEventListener('click', function (e) {
  var btn = e.target && e.target.closest ? e.target.closest('[data-cj-buynow]') : null;
  if (!btn || btn.disabled) return;
  e.preventDefault();
  var form = btn.closest('form[action*="/cart/add"]');
  var id = (form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value) || btn.getAttribute('data-variant');
  var qtyEl = form && form.querySelector('[name="quantity"]');
  var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
  if (!id) return;
  btn.classList.add('is-busy');
  fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
  })
    .then(function () { window.location.href = '/checkout'; })
    .catch(function () { btn.classList.remove('is-busy'); window.location.href = '/cart'; });
});
